<script setup>
import { computed } from 'vue';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';
import { useAlert } from 'dashboard/composables';

const props = defineProps({
  pixKey: {
    type: String,
    required: true,
  },
  merchant: {
    type: String,
    default: '',
  },
});

const { getPlainText } = useMessageFormatter();

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(props.pixKey);
    useAlert(
      window.chatwootConfig.i18n.t('COMPONENTS.CODE_BUBBLE.COPY_SUCCESSFUL')
    );
  } catch (error) {
    // Fallback or silence
  }
};
</script>

<template>
  <div
    class="flex flex-row items-start justify-start gap-2 w-full py-2 px-1 cursor-pointer overflow-hidden"
  >
    <div
      class="flex items-center justify-center w-10 h-10 rounded-full bg-surface-hover flex-shrink-0 text-woot-600 dark:text-woot-500"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        width="24px"
        height="24px"
        viewBox="0 0 16 16"
      >
        <path
          d="M11.917 11.71a2.046 2.046 0 0 1-1.454-.602l-2.1-2.1a.4.4 0 0 0-.551 0l-2.108 2.108a2.044 2.044 0 0 1-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 0 0 .552 0l2.1-2.1a2.044 2.044 0 0 1 1.453-.602h.253L9.503 1.623a2.127 2.127 0 0 0-3.007 0l-2.66 2.66h.414z"
        />
        <path
          d="m14.377 6.496-1.612-1.612a.307.307 0 0 1-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 0 1-1.425 0L5.268 5.32a1.448 1.448 0 0 0-1.018-.422h-.9a.306.306 0 0 1-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 0 1 .108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 0 1 1.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z"
        />
      </svg>
    </div>
    <div class="flex flex-col items-start flex-1 min-w-0">
      <h5 class="text-sm font-semibold text-body truncate m-0 w-full">Pix</h5>
      <p v-if="merchant" class="text-xs text-muted truncate w-full mb-1">
        {{ merchant }}
      </p>

      <div class="flex items-center gap-2 w-full mt-1">
        <div
          class="bg-surface-hover rounded-lg px-2 py-1 text-xs font-mono text-muted truncate flex-1 border border-line select-all"
        >
          {{ pixKey }}
        </div>
        <button
          class="flex items-center justify-center p-1.5 rounded-md hover:bg-surface-hover transition-colors text-muted"
          :title="$t('COMPONENTS.CODE_BUBBLE.COPY')"
          @click.stop="copyToClipboard"
        >
          <fluent-icon icon="copy" size="16" />
        </button>
      </div>
    </div>
  </div>
</template>
